module.exports = __webpack_public_path__ + "static/media/menu.2727cb91.svg";